"use client";

/**
 * AI SDK Elements — `message`. Copiat del registre (no és un paquet), com `tool.tsx`:
 *   https://registry.ai-sdk.dev/message.json · versió del registre del 13-OCT-2026.
 * Documentació: https://elements.ai-sdk.dev/docs
 *
 * [Guilleumes] Només se n'han copiat `Message` i `MessageContent`, tal com són. Queden fora, a
 * posta:
 *  - `MessageResponse`: és un embolcall de `streamdown`, una dependència nova. El text de Miranda
 *    es pinta amb `MarkdownMessage`, que ja hi és i no es toca.
 *  - `MessageActions`, `MessageBranch*`, `MessageAttachment*`: demanen `ui/button-group`, que
 *    aquest projecte no té, i el xat no en fa servir cap (ni branques ni adjunts a la bombolla).
 * Si mai calen, es tornen a copiar del registre.
 */

import { cn } from "@/lib/utils";
import type { UIMessage } from "ai";
import type { HTMLAttributes } from "react";

export type MessageProps = HTMLAttributes<HTMLDivElement> & {
  from: UIMessage["role"];
};

export const Message = ({ className, from, ...props }: MessageProps) => (
  <div
    className={cn(
      "group flex w-full max-w-[95%] flex-col gap-2",
      from === "user" ? "is-user ml-auto justify-end" : "is-assistant",
      className
    )}
    {...props}
  />
);

export type MessageContentProps = HTMLAttributes<HTMLDivElement>;

export const MessageContent = ({
  children,
  className,
  ...props
}: MessageContentProps) => (
  <div
    className={cn(
      "is-user:dark flex w-fit max-w-full min-w-0 flex-col gap-2 overflow-hidden text-sm",
      "group-[.is-user]:ml-auto group-[.is-user]:rounded-lg group-[.is-user]:bg-secondary group-[.is-user]:px-4 group-[.is-user]:py-3 group-[.is-user]:text-foreground",
      "group-[.is-assistant]:text-foreground",
      className
    )}
    {...props}
  >
    {children}
  </div>
);
